import ExportImage from "../../../images/Export.svg";
import "./pictureDisplaySelector.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function PictureDisplaySelector({
  onMediaChange,
  initialMediaUrl,
  error,
  title,
  isVideo,
  onGenerate,
  canGenerate = false,
  generating = false,
  remainingGenerations = 3,
  generatedCandidates = [],
  onSelectGenerated,
}) {
  const { t } = useTranslation("pictureDisplaySelector");

  return (
    <>
      <section className={`pictureContainer ${error ? "errorInput" : ""}`}>
        {initialMediaUrl ? (
          <>
            <div className="pictureWrapper">
              {isVideo ? (
                <video
                  className="picture"
                  src={initialMediaUrl}
                  autoPlay
                  playsInline
                  loop
                  muted
                ></video>
              ) : (
                <img src={initialMediaUrl} className="picture" alt="" />
              )}
            </div>
            <h1 className="eventTitle">{title}</h1>
          </>
        ) : (
          <h1>{t("noImageYet")}</h1>
        )}

        <input type="file" id="fileUpload" style={{ display: "none" }} onChange={onMediaChange} />
        <div className="pictureActions">
          <button
            type="button"
            onClick={() => document.getElementById("fileUpload").click()}
            className="imageUploadButton"
          >
            <img src={ExportImage} alt="" />
            <p>{t("uploadMedia")}</p>
          </button>
          {onGenerate ? (
            <button
              type="button"
              className="aiGenerateButton"
              onClick={onGenerate}
              disabled={!canGenerate || generating || remainingGenerations <= 0}
            >
              {generating
                ? t("generatingWithAi")
                : `${generatedCandidates.length ? t("regenerateWithAi") : t("generateWithAi")} (${remainingGenerations})`}
            </button>
          ) : null}
        </div>
        {generating ? <p className="aiGenerationNotice">{t("generationMayTake")}</p> : null}
      </section>
      {generatedCandidates.length ? (
        <div className="generatedCoverCandidates">
          {generatedCandidates.map((candidate) => (
            <button
              type="button"
              key={candidate.storagePath}
              className={candidate.downloadUrl === initialMediaUrl ? "selected" : ""}
              onClick={() => onSelectGenerated?.(candidate)}
            >
              <img src={candidate.downloadUrl} alt={t("generatedCoverAlternative")} />
            </button>
          ))}
        </div>
      ) : null}
      {error && <p className="errorMessage">{error}</p>}
    </>
  );
}

PictureDisplaySelector.propTypes = {
  onMediaChange: PropTypes.func.isRequired,
  initialMediaUrl: PropTypes.string,
  error: PropTypes.string,
  onGenerate: PropTypes.func,
  canGenerate: PropTypes.bool,
  generating: PropTypes.bool,
  remainingGenerations: PropTypes.number,
  generatedCandidates: PropTypes.array,
  onSelectGenerated: PropTypes.func,
};

export default PictureDisplaySelector;
